import React from "react";

export const IMGATTACH_LANG = (formatMessage) => {
    let MULTI_LANG = {
        VALIDATE_MESSAGE_NOT_UPLOAD_EXT                 : formatMessage({id: "img_attach.validate.notUploadExt", defaultMessage: "업로드 불가능한 확장자 입니다."}),
        VALIDATE_MESSAGE_NOT_UPLOAD_SIZE             : formatMessage({id: "img_attach.validate.notUploadSize", defaultMessage: "업로드 가능한 파일 크기는 5MB 입니다."}),
    }
    
    return MULTI_LANG;
};